import { render, staticRenderFns } from "./contract-files-table.vue?vue&type=template&id=c49b4246&"
import script from "./contract-files-table.vue?vue&type=script&lang=js&"
export * from "./contract-files-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c49b4246')) {
      api.createRecord('c49b4246', component.options)
    } else {
      api.reload('c49b4246', component.options)
    }
    module.hot.accept("./contract-files-table.vue?vue&type=template&id=c49b4246&", function () {
      api.rerender('c49b4246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl223/partials/contract-files-table.vue"
export default component.exports